import React from "react";
import { observer } from "mobx-react-lite";

import Button from "../button/Button";
import { Info } from "../svg/svgImageList";
import ProgressBarSnackbar from "../progress-bar-snackbar/ProgressBarSnackbar";
import { translationService } from "../../services/translation/TranslationService";
import { uploadFilesService } from "../../services/upload/UploadFilesService";

export default observer(() => {
  return (
    <div
      className={`batch-processing-progress ${
        uploadFilesService.uploadSnackbarIsVisible ? "show" : "hide"
      }`}
    >
      <div className="info">
        <Button
          className="svg-info"
          icon={{
            svg: Info,
            width: 30,
            height: 30,
          }}
        />
        <span>{translationService.translate("general.upload.uploading-files")}</span>
        <Button
          className={"btn-text"}
          onClick={uploadFilesService.showUploadProgress}
          textKey="general.upload.view-details"
        />
      </div>
      <div className="progress-bar-with-stop">
        <ProgressBarSnackbar percentComplete={uploadFilesService.uploadProgress.progress} />
        <span>
          {`${uploadFilesService.filesUploadStatus.filter((x) => x.wrapper.isFinished).length} /
            ${uploadFilesService.filesUploadStatus.length}`}
        </span>
      </div>
    </div>
  );
});
